export function generateColor(
  key: keyof ProposalColor,
  proposal: Proposal,
): string {
  return proposal.style?.color?.[key];
}
